import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export const savePageDraftAction = (payload: any) => ({
  type: ReduxActionTypes.SAVE_PAGE_DRAFT,
  payload,
});

export const getPageDraftAction = (payload: any) => ({
  type: ReduxActionTypes.GET_PAGE_DRAFT,
  payload,
});

export const getPageDraftSuccessAction = (payload: any) => ({
  type: ReduxActionTypes.GET_PAGE_DRAFT_SUCCESS,
  payload,
});

export const saveDraftSuccessAction = (payload: any) =>{
  return ({
    type: ReduxActionTypes.SAVE_DRAFT_SUCCESS,
    payload,
  });
};

export const restoreDraftAction = (payload: any) => ({
  type: ReduxActionTypes.RESTORE_DRAFT,
  payload,
});

export const restoreDraftSuccessAction = (payload: any) => ({
  type: ReduxActionTypes.RESTORE_DRAFT_SUCCESS,
  payload,
});

export const deleteDraftAction = (payload: any) => ({
  type: ReduxActionTypes.DELETE_DRAFT,
  payload,
});

export const deleteDraftSuccessAction = (payload: any) => ({
  type: ReduxActionTypes.DELETE_DRAFT_SUCCESS,
  payload,
});


